import { defineGameCard, onResolve } from '../authoring/index.js';
export const EmergencyVentCard = defineGameCard({
    id: 'emergency_vent',
    gameplay: {
        type: 'SPELL', cost: 2,
        planning: { target: 'none' },
    },
    presentation: {
        name: 'Аварийная продувка',
        description: 'Нанесите 1 урон всем своим перегретым картам, затем охладите выжившие на 2. Возьмите карту.',
        glyph: {
            colors: ['#B7C3C2', '#10213A', '#51626C', '#3B4653', '#A7753D'],
            rows: [
                '11..................',
                '..1.................',
                '11.1................',
                '..1.1222............',
                '11.113332...........',
                '..11.33342.2222.....',
                '11..133434233342....',
                '..11133433433432222.',
                '11111334334334325552',
                '..11.333332333425552',
                '.1.114422244442.252.',
                '1.1.122.244442..252.',
                '.1.1....243332..252.',
                '1.1.....233332...2..',
                '.1......2433342.....',
                '1......243333342....',
                '.......244443442....',
                '........2222222.....',
                '........2333342.....',
                '.........22222......',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve((ctx) => {
            const snapshot = ctx.q.unitsOf(ctx.self.controllerId)
                .filter((unit) => unit.heat > 0)
                .map((unit) => unit.id);
            for (const instanceId of snapshot)
                ctx.ops.dealDamage({ kind: 'unit', instanceId }, 1);
            for (const instanceId of snapshot) {
                const survivor = ctx.q.allUnits().find((unit) => unit.id === instanceId);
                if (survivor !== undefined && ctx.q.stats(survivor).health > 0) {
                    ctx.ops.cool(instanceId, 2);
                }
            }
            ctx.ops.drawCard(ctx.self.controllerId, 1);
        }),
    ],
    ui: { mechanics: ['cool'] },
});
//# sourceMappingURL=emergency-vent.js.map